import React from "react";
import PropTypes from "prop-types";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {ArrowDropDown} from "@material-ui/icons";
import authLib from "../../../../lib/auth";
import LinkMenuItem from "../../components/LinkMenuItem";

import "./style.scss";

export default class SessionsMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      menuTarget: null
    };
  }
  toggleMenu = e => {
    this.setState({menuOpen: !this.state.menuOpen, menuTarget: e.target});
  };

  switchAccounts = session => {
    authLib.become(session);
  };

  renderSessionMenu(sessions, accountId) {
    const {menuOpen, menuTarget} = this.state;
    return (
      <Menu className="scrollAccountList" open={menuOpen} onClose={this.toggleMenu} anchorEl={menuTarget}>
        {sessions.map((session, index) => (
          <MenuItem
            className="accountDropdownItem"
            key={"session" + index}
            selected={session.account_id === accountId}
            onClick={() => this.switchAccounts(session)}>
            {session.account_name}
          </MenuItem>
        ))}
      </Menu>
    );
  }
  render() {
    const {sessions, account} = this.props;
    return (
      <React.Fragment>
        <LinkMenuItem
          onClick={this.toggleMenu}
          primary={<p className="menuItemText sessionsMenuItem">{account.get("name")}</p>}
          iconRight={<ArrowDropDown />}
          disabled={sessions.length < 2}
          className="sessionsMenuItem"
        />
        {this.renderSessionMenu(sessions, account.get("_id"))}
      </React.Fragment>
    );
  }
}

SessionsMenu.propTypes = {
  sessions: PropTypes.array.isRequired,
  account: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/Menus/SessionsMenu/index.jsx